<!-- display-desktop-03 preview — publisher site (desktop), single hotel card in the sidebar -->
<app-desktop-frame>
  <div class="gs-page">
    <!-- START: Site header -->
    <i class="bi bi-person-circle gs-account"></i>
    <div class="gs-site-name">website</div>
    <div class="gs-nav d-flex flex-row align-items-center">
      <span *ngFor="let _ of navItems" class="gs-skel gs-skel-nav"></span>
      <span class="gs-nav-icons d-flex flex-row align-items-center">
        <i class="bi bi-search"></i>
        <i class="bi bi-arrow-90deg-right"></i>
        <i class="bi bi-share"></i>
        <i class="bi bi-envelope"></i>
        <i class="bi bi-rss"></i>
      </span>
    </div>
    <!-- END: Site header -->

    <div class="gs-content d-flex flex-row">
      <!-- Article, context only -->
      <div class="gs-article" aria-hidden="true">
        <span *ngFor="let w of articleLines" class="gs-skel gs-skel-line" [style.width.%]="w"></span>
        <span class="gs-skel gs-skel-media"></span>
      </div>

      <!-- START: Real ad -->
      <div class="gs-promo">
        <div class="gs-brand-row d-flex flex-row align-items-center">
          <span class="gs-logo"><img src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png" alt="" /></span>
          <div class="gs-brand-info">
            <a class="gs-long-headline" [href]="data.url || null" target="_blank" rel="noopener noreferrer">
              {{ longHeadline }}
            </a>
            <div class="gs-brand-name">Valamar</div>
          </div>
          <i class="bi bi-info-circle gs-info"></i>
        </div>

        <!-- Hotel card: no template field, so it is static -->
        <a class="gs-card d-flex flex-column" [href]="data.url || null" target="_blank" rel="noopener noreferrer">
          <span class="gs-card-image"><img [src]="hotel.image" alt="" /></span>
          <span class="gs-card-title">{{ hotel.title }}</span>
          <span class="gs-card-footer d-flex flex-row align-items-center">
            <span class="gs-card-subtitle">{{ hotel.subtitle }}</span>
            <span class="gs-card-cta">{{ ctaText }}</span>
          </span>
        </a>
      </div>
      <!-- END: Real ad -->
    </div>
  </div>
</app-desktop-frame>
